import { HttpClient, HttpHeaders, HttpXsrfTokenExtractor } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap,map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router'; 
import { UserInfoService } from 'src/app/shared/UserInfo/user-info.service';
import { CitiesService } from '../../cities/services/cities.service';
interface LoginResponse {
  success: boolean;
  'session-token': string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(
    private http: HttpClient, 
    private router: Router, 
    private userInfoService: UserInfoService,
    private citiesService: CitiesService
  ) {}

  login(credentials: { username: string, password: string }): Observable<any> {
    const formData = new FormData();
    formData.append('username', credentials.username);
    formData.append('password', credentials.password);

    return this.http.post(`${environment.apiUrl}/authenticate`, formData, { responseType: 'text' }).pipe(
      map(response => {
        try {
          const result = JSON.parse(response);
          this.userInfoService.setAuthToken(result.access_token);
          delete result.access_token;
          this.userInfoService.setUserInfo(result);
          this.citiesService.setUserSelectedCity(result.default_city);
          return response;
        } catch (error) {
          return response;
        }
      })
    );
  }
  
  logout() {
    this.userInfoService.removeAuthToken();
    this.userInfoService.removeUserInfo();
    this.router.navigate(['/login']);
  }


  isLoggedIn(): boolean {
    const token = this.userInfoService.getAuthToken();
    return !!token;
  }
}



